
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31020",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31020",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55605",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8515",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11964",
  "I18n": "static-7.1708",
  "quartz": "static-1.7659",
  "quartz-config": "static-1.1437",
  "quartz-core": "static-1.6878",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1099",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55592",
  "feedback-utils": "static-1.55596",
  "forms-embed-utils-lib": "static-1.4937",
  "forms-utils-lib": "static-1.13340",
  "foundations-assets": "static-1.5362",
  "foundations-components": "static-1.8752",
  "foundations-theming": "static-1.4964",
  "hub-http": "static-1.6683",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12271",
  "icons": "static-2.703",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4233",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17214",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.518",
  "tinymce-plugins": "static-1.58513",
  "transmute": "static-2.97",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8910",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3936",
  "quartz-webpack": "static-1.3883",
  "foundations-theming-specialty": "static-1.2680",
  "property-description-translator": "static-1.4297",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3626",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4784",
  "jasmine-runner": "static-1.6928",
  "opentelemetry-fe-types": "static-1.268",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4977",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.643",
  "quartz-auth": "static-1.1334",
  "quartz-head": "static-1.1324",
  "quartz-i18n": "static-1.1334",
  "quartz-routing": "static-1.1089",
  "quartz-test": "static-1.1334",
  "quartz-tracking": "static-1.1038",
  "trellis-components": "static-1.3112",
  "ui-fonts": "static-1.1226",
  "usage-tracker-container": "static-1.7791",
  "usage-tracker-core": "static-1.7651",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.365",
  "conversations-skeleton-state": "static-1.7608",
  "reference-resolvers": "static-1.8660",
  "sanitize-text": "static-1.8635",
  "PatternValidationJS": "static-1.3362",
  "ReduxMessenger": "static-2.10847",
  "outpost": "static-1.4605",
  "rpc-client-utils": "static-1.5146",
  "sanitize": "static-1.4951",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5021",
  "floating-ui": "static-1.68",
  "hs-story-utils": "static-1.9902",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3093",
  "bend-plugin-foundations-theming": "static-1.3447",
  "foundations-theming-base": "static-1.3949",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.402",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.177",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10021",
  "atom": "static-1.5549",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8425",
  "ContentUtils": "static-1.69475",
  "data-token-picker": "static-1.17138",
  "file-manager-components": "static-1.24844",
  "FileManagerCore": "static-1.40343",
  "FileManagerLib": "static-1.40484",
  "frontend-preferences-client": "static-1.8397",
  "hub-http-contrib": "static-1.3509",
  "interframe": "static-3.5218",
  "layout-dnd-components": "static-1.13232",
  "layout-dnd-utils": "static-1.12207",
  "property-translator": "static-1.5857",
  "react-codemirror": "static-1.11118",
  "react-colorpicker": "static-2.10686",
  "reference-resolvers-lite": "static-1.8588",
  "rich-text-lib": "static-1.20558",
  "tinymce-data": "static-1.41484",
  "tinymce-themes": "static-1.57369",
  "ui-addon-emoji-picker": "static-1.10340",
  "ui-addon-sales-email": "static-1.5678",
  "ui-brand-identity-lib": "static-1.16952",
  "bender-build-tools": "static-1.3589",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10905",
  "hubspotter-http-shared-msw-handlers": "static-1.10903",
  "usage-tracker-session-replay": "static-1.5487",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1482",
  "tanstack-virtual": "static-1.43",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.556",
  "chirp-fetch": "static-1.2381",
  "stylex-utils": "static-1.175",
  "chatspot-core": "static-1.23892",
  "copilot-toolkit": "static-1.12151",
  "customer-data-objects-ui-components": "static-1.13512",
  "data-fetching-client": "static-1.10117",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5236",
  "ui-addon-video-player": "static-1.9100",
  "ui-coaching-tips": "static-1.29585",
  "usage-tracker": "static-1.7801",
  "cms-field-types": "static-1.5287",
  "content-icons-ui": "static-1.2458",
  "integrations-lib": "static-1.17432",
  "customer-data-objects": "static-1.8180",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2187",
  "apollo-link-hub-http": "static-2.5064",
  "apollo-stack-hubspot": "static-3.99",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4618",
  "poll-commands": "static-1.3954",
  "ui-addon-iframeable": "static-1.9552",
  "video-components-external": "static-1.12433",
  "video-data-lib": "static-1.36091",
  "audio-components": "static-1.6574",
  "breeze-artifacts-sdk": "static-1.958",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30065",
  "FileManagerImages": "static-1.37995",
  "foundations-components-legacy": "static-1.1777",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.734",
  "ui-universal-auth": "static-1.9746",
  "urlinator": "static-1.4991",
  "video-components": "static-1.14435",
  "video-embed": "static-1.36925",
  "ts-schema": "static-1.4395",
  "ContentData": "static-1.69550",
  "layout-data-lib": "static-1.10532",
  "react-dnd-compat": "static-1.5086",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2025",
  "external-options-client-types": "static-1.4441",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6069",
  "hs-resources": "static-1.667",
  "inbound-db-properties-service-client": "static-1.4153",
  "NamespacedHubStyle": "static-2.9369",
  "growth-onboarding-confetti": "static-1.3535",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11622",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5909",
  "magpie-types": "static-1.5369",
  "simple-logging-lib": "static-1.3528",
  "avatar-components": "static-1.2962",
  "customer-data-ui-utilities": "static-1.10308",
  "growth-onboarding-feedback-components": "static-1.7057",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5357",
  "integrations-error-boundary-lib": "static-1.14847",
  "integrations-tracking-lib": "static-1.6096",
  "laboratory-lib": "static-3.7623",
  "native-integrations-shared-strings": "static-1.8240",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10755",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1165",
  "breeze-engine-core": "static-1.1465",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1123",
  "navigation-messaging": "static-1.8496",
  "content-media-composition-data-lib": "static-1.13595",
  "content-media-compositions": "static-2.17602",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19646",
  "nudge-client-utils": "static-1.3422",
  "custom-vendor-connection-lib": "static-1.310",
  "unified-auth-core-lib": "static-1.1542",
  "social-insights-client-types": "static-1.22933",
  "advanced-menus-core": "static-1.15818",
  "advanced-menus-lib": "static-1.12571",
  "ExportDialog": "static-6.10851",
  "ui-memberships-settings-lib": "static-1.35197",
  "conditional-properties-service-client": "static-1.4115",
  "crm-pipelines-api-client-types": "static-1.4445",
  "event-emitter": "static-1.1438",
  "fdsr-migration-layer": "static-1.487",
  "framework-builder-read-service-client": "static-1.4337",
  "inbound-db-meta-service-client": "static-1.3776",
  "multi-currency-client-types": "static-1.4009",
  "foundations-components-test-utils": "static-1.6235",
  "reactive-lib": "static-1.1196",
  "trellis-migration-context": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.816",
  "universal-page-editor-lib": "static-1.3487",
  "bend-plugin-pulse": "static-1.626",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30806",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3179",
  "nudge-renderer-utils": "static-1.3498",
  "onboarding-tours": "static-1.17407",
  "whisper-core-api": "static-1.7638",
  "fsm": "static-1.4234",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15817",
  "simple-menus-lib": "static-1.17334",
  "settings-ui-lib": "static-1.13004",
  "persist-promise": "static-1.4182",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7368",
  "location-customization-utils-lib": "static-1.10421",
  "getting-started-shared-tasks": "static-1.19565",
  "growth-data-modal": "static-1.6136",
  "growth-onboarding-next-action-utils": "static-1.2986",
  "navigation-components": "static-1.19169",
  "nest": "static-1.712",
  "onboarding-tours-client": "static-1.5622",
  "onboarding-tours-utils": "static-1.1474",
  "ui-shepherd-tracker": "static-1.8136",
  "user-context": "static-1.5530",
  "react-flip-move": "static-1.83",
  "framework-data-schema-quick-fetch": "static-1.7273",
  "onboarding-data-sync-lib": "static-1.2843",
  "growth-onboarding-next-action-components": "static-1.3014",
  "user-context-client": "static-1.4986",
  "getting-started-shared-tasks-store": "static-1.18683",
  "InboxConnectUtils": "static-4.15846",
  "meetings-connect-utils-lib": "static-1.8095",
  "onboarding-scopes": "static-1.6929"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31020",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55605",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8515",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11964",
  "I18n": "/I18n/static-7.1708",
  "quartz": "/quartz/static-1.7659",
  "quartz-config": "/quartz-config/static-1.1437",
  "quartz-core": "/quartz-core/static-1.6878",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1099",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55592",
  "feedback-utils": "/feedback-utils/static-1.55596",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4937",
  "forms-utils-lib": "/forms-utils-lib/static-1.13340",
  "foundations-assets": "/foundations-assets/static-1.5362",
  "foundations-components": "/foundations-components/static-1.8752",
  "foundations-theming": "/foundations-theming/static-1.4964",
  "hub-http": "/hub-http/static-1.6683",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12271",
  "icons": "/icons/static-2.703",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17214",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tinymce-plugins": "/tinymce-plugins/static-1.58513",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8910",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3936",
  "quartz-webpack": "/quartz-webpack/static-1.3883",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2680",
  "property-description-translator": "/property-description-translator/static-1.4297",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3626",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4784",
  "jasmine-runner": "/jasmine-runner/static-1.6928",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.268",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.643",
  "quartz-auth": "/quartz-auth/static-1.1334",
  "quartz-head": "/quartz-head/static-1.1324",
  "quartz-i18n": "/quartz-i18n/static-1.1334",
  "quartz-routing": "/quartz-routing/static-1.1089",
  "quartz-test": "/quartz-test/static-1.1334",
  "quartz-tracking": "/quartz-tracking/static-1.1038",
  "trellis-components": "/trellis-components/static-1.3112",
  "ui-fonts": "/ui-fonts/static-1.1226",
  "usage-tracker-container": "/usage-tracker-container/static-1.7791",
  "usage-tracker-core": "/usage-tracker-core/static-1.7651",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.365",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "reference-resolvers": "/reference-resolvers/static-1.8660",
  "sanitize-text": "/sanitize-text/static-1.8635",
  "PatternValidationJS": "/PatternValidationJS/static-1.3362",
  "ReduxMessenger": "/ReduxMessenger/static-2.10847",
  "outpost": "/outpost/static-1.4605",
  "rpc-client-utils": "/rpc-client-utils/static-1.5146",
  "sanitize": "/sanitize/static-1.4951",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5021",
  "floating-ui": "/floating-ui/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9902",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3093",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3447",
  "foundations-theming-base": "/foundations-theming-base/static-1.3949",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.177",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10021",
  "atom": "/atom/static-1.5549",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8425",
  "ContentUtils": "/ContentUtils/static-1.69475",
  "data-token-picker": "/data-token-picker/static-1.17138",
  "file-manager-components": "/file-manager-components/static-1.24844",
  "FileManagerCore": "/FileManagerCore/static-1.40343",
  "FileManagerLib": "/FileManagerLib/static-1.40484",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8397",
  "hub-http-contrib": "/hub-http-contrib/static-1.3509",
  "interframe": "/interframe/static-3.5218",
  "layout-dnd-components": "/layout-dnd-components/static-1.13232",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12207",
  "property-translator": "/property-translator/static-1.5857",
  "react-codemirror": "/react-codemirror/static-1.11118",
  "react-colorpicker": "/react-colorpicker/static-2.10686",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8588",
  "rich-text-lib": "/rich-text-lib/static-1.20558",
  "tinymce-data": "/tinymce-data/static-1.41484",
  "tinymce-themes": "/tinymce-themes/static-1.57369",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10340",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5678",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16952",
  "bender-build-tools": "/bender-build-tools/static-1.3589",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10905",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10903",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5487",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1482",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.556",
  "chirp-fetch": "/chirp-fetch/static-1.2381",
  "stylex-utils": "/stylex-utils/static-1.175",
  "chatspot-core": "/chatspot-core/static-1.23892",
  "copilot-toolkit": "/copilot-toolkit/static-1.12151",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13512",
  "data-fetching-client": "/data-fetching-client/static-1.10117",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5236",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9100",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29585",
  "usage-tracker": "/usage-tracker/static-1.7801",
  "cms-field-types": "/cms-field-types/static-1.5287",
  "content-icons-ui": "/content-icons-ui/static-1.2458",
  "integrations-lib": "/integrations-lib/static-1.17432",
  "customer-data-objects": "/customer-data-objects/static-1.8180",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2187",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5064",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4618",
  "poll-commands": "/poll-commands/static-1.3954",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9552",
  "video-components-external": "/video-components-external/static-1.12433",
  "video-data-lib": "/video-data-lib/static-1.36091",
  "audio-components": "/audio-components/static-1.6574",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.958",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30065",
  "FileManagerImages": "/FileManagerImages/static-1.37995",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1777",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.734",
  "ui-universal-auth": "/ui-universal-auth/static-1.9746",
  "urlinator": "/urlinator/static-1.4991",
  "video-components": "/video-components/static-1.14435",
  "video-embed": "/video-embed/static-1.36925",
  "ts-schema": "/ts-schema/static-1.4395",
  "ContentData": "/ContentData/static-1.69550",
  "layout-data-lib": "/layout-data-lib/static-1.10532",
  "react-dnd-compat": "/react-dnd-compat/static-1.5086",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2025",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6069",
  "hs-resources": "/hs-resources/static-1.667",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3535",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11622",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5909",
  "magpie-types": "/magpie-types/static-1.5369",
  "simple-logging-lib": "/simple-logging-lib/static-1.3528",
  "avatar-components": "/avatar-components/static-1.2962",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10308",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7057",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5357",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14847",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6096",
  "laboratory-lib": "/laboratory-lib/static-3.7623",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8240",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10755",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1165",
  "breeze-engine-core": "/breeze-engine-core/static-1.1465",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1123",
  "navigation-messaging": "/navigation-messaging/static-1.8496",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13595",
  "content-media-compositions": "/content-media-compositions/static-2.17602",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19646",
  "nudge-client-utils": "/nudge-client-utils/static-1.3422",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.310",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1542",
  "social-insights-client-types": "/social-insights-client-types/static-1.22933",
  "advanced-menus-core": "/advanced-menus-core/static-1.15818",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12571",
  "ExportDialog": "/ExportDialog/static-6.10851",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35197",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "event-emitter": "/event-emitter/static-1.1438",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.487",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6235",
  "reactive-lib": "/reactive-lib/static-1.1196",
  "trellis-migration-context": "/trellis-migration-context/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.816",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3487",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.626",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30806",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3179",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3498",
  "onboarding-tours": "/onboarding-tours/static-1.17407",
  "whisper-core-api": "/whisper-core-api/static-1.7638",
  "fsm": "/fsm/static-1.4234",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15817",
  "simple-menus-lib": "/simple-menus-lib/static-1.17334",
  "settings-ui-lib": "/settings-ui-lib/static-1.13004",
  "persist-promise": "/persist-promise/static-1.4182",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7368",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10421",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19565",
  "growth-data-modal": "/growth-data-modal/static-1.6136",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2986",
  "navigation-components": "/navigation-components/static-1.19169",
  "nest": "/nest/static-1.712",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5622",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1474",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8136",
  "user-context": "/user-context/static-1.5530",
  "react-flip-move": "/react-flip-move/static-1.83",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7273",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2843",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3014",
  "user-context-client": "/user-context-client/static-1.4986",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18683",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15846",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8095",
  "onboarding-scopes": "/onboarding-scopes/static-1.6929"
}
};
